module.exports = __webpack_public_path__ + "ravenlight_cosplay.jpg?c0dbb42472f7877dab49dfc8b1d9cf90";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/ravenlight_cosplay.jpg
// module id = 710
// module chunks = 0